import {Button, Dialog} from '@wandb/components';
import {maybePluralize} from '@wandb/weave/core/util/string';
import React from 'react';

type KeyBasedColorsConfirmModalProps = {
  isOpen: boolean;
  /**
   * Entries in the custom run colors map. Counts group colors as well as
   * per-run colors, both of which get cleared.
   */
  numCustomRunColors: number;
  onCancel: () => void;
  onConfirm: () => void;
};

/**
 * Confirms clearing custom run colors before switching to key-based colors.
 * Custom colors win over key-based colors when a run's color is resolved, so
 * any run that keeps one wouldn't pick up the new mode.
 */
export const KeyBasedColorsConfirmModal = ({
  isOpen,
  numCustomRunColors,
  onCancel,
  onConfirm,
}: KeyBasedColorsConfirmModalProps) => {
  const isSingular = numCustomRunColors === 1;

  return (
    <Dialog.Modal
      isAlert
      isOpen={isOpen}
      onOpenChange={open => !open && onCancel()}>
      <Dialog.Heading>Clear custom run colors?</Dialog.Heading>
      <Dialog.Content>
        <p>
          {maybePluralize(numCustomRunColors, 'custom run color')} currently{' '}
          {isSingular ? 'is' : 'are'} set. Clear {isSingular ? 'it' : 'them'} to
          apply key-based colors to all runs.
        </p>
      </Dialog.Content>
      <Dialog.Footer>
        <Button variant="destructive" onPress={onConfirm}>
          Clear and apply
        </Button>
        <Button variant="secondary" onPress={onCancel}>
          Cancel
        </Button>
      </Dialog.Footer>
    </Dialog.Modal>
  );
};
